import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=5cc3d01e&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=5cc3d01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3d01e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc3d01e')) {
      api.createRecord('5cc3d01e', component.options)
    } else {
      api.reload('5cc3d01e', component.options)
    }
    module.hot.accept("./Wizard.vue?vue&type=template&id=5cc3d01e&scoped=true&", function () {
      api.rerender('5cc3d01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/Wizard.vue"
export default component.exports